import { useQuery, type UseQueryResult } from '@tanstack/react-query';

export type CurrentUserDataType = {
    id: number;
    status: number;
    availableBalance: number;
    currentBalance: number;
    productId: number;
    productReference: string;
    entityAccountRelationships: {
        id: number;
        accountId: number;
        entityId: number;
        relationshipType: string;
        status: number;
        CardBase: unknown;
    };
    entityId: number;
    cards: {
        id: string;
        entityId: number;
    }[];
};


const useCurrentUserQuery = (): UseQueryResult<CurrentUserDataType> => {
    return useQuery({
        queryKey: ['currentUser'],
        queryFn: async() => {
            const response = await fetch('/api/Indue/accounts/current');
            if (!response.ok) {
                throw new Error('Failed to fetch current user account');
            }

            const responseData = await response.json();

            if (!responseData) {
                throw new Error('Could not retrieve the current user data');
            }

            return responseData;
        },
        staleTime: Infinity,
    });
};

export default useCurrentUserQuery;
